var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 109 9 9 9 0 00-9-9zm0 16a7 7 0 117-7 6.995 6.995 0 01-7 7zm-1.46-5.47L5.41 8.4 4.35 9.46l3.18 3.18 6-6-1.06-1.06-4.93 4.95z",
    fill: "#16c98d"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMiw0YTksOSwwLDEsMCw5LDlBOSw5LDAsMCwwLDEyLDRabTAsMTZhNyw3LDAsMSwxLDctN0E2Ljk5NSw2Ljk5NSwwLDAsMSwxMiwyMFptLTEuNDYtNS40N0w4LjQxLDEyLjQsNy4zNSwxMy40NmwzLjE4LDMuMTgsNi02TDE1LjQ3LDkuNThsLTQuOTMsNC45NVoiCiAgICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC00KSIKICAgICAgICAgICAgZmlsbD0iIzE2Yzk4ZCIKICAgIC8+Cjwvc3ZnPg==";
export { SvgCheckCircle as ReactComponent };